import { createElement, useState } from 'react';
import { Handshake, MessageSquareHeart, Ticket } from 'lucide-react';
import { MemberGetMemberPage } from './MemberGetMemberPage.jsx';
import { SurveyDashboard } from './SurveyDashboard.jsx';
import { VoucherClaimPage } from './VoucherClaimPage.jsx';

const TABS = [
  { key: 'member', label: 'Member Get Member', icon: Handshake },
  { key: 'survey', label: 'Survey Kepuasan', icon: MessageSquareHeart },
  { key: 'voucher', label: 'Klaim Voucher', icon: Ticket },
];

export function MembershipPage() {
  const [tab, setTab] = useState('member');
  return (
    <div className="page-stack">
      <div className="membership-tabs" role="tablist" aria-label="Membership">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button key={key} type="button" role="tab" aria-selected={tab === key}
            className={`button ${tab === key ? 'button-primary' : 'button-quiet'}`}
            onClick={() => setTab(key)}>
            {createElement(Icon, { size: 16 })} {label}
          </button>
        ))}
      </div>
      {tab === 'member' ? <MemberGetMemberPage /> : null}
      {tab === 'survey' ? <SurveyDashboard /> : null}
      {tab === 'voucher' ? <VoucherClaimPage /> : null}
    </div>
  );
}
